<template>
<!--流量充值-->
 <div id="billdirect">
 	<mt-header :title="title"  fixed>
	  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
	  </a>
	</mt-header>
 	<div class="mt40 border-bottom-line">
 	    <div :class="{mt401:cellCore!=''}">
		 	 <mt-field label="手机号码" placeholder="请输入手机号码" type="tel" v-model="phone" :attr="{ maxlength: 11 }" @input="queryInfo"></mt-field>
		 	 <p class="ml120 font-size8 colora9a9a9 mb2" v-show="cellCore!=''">({{cellCore}})</p>
	 	</div>
 	</div>
 	<div class="bgcontent border-bottom-line">
 	 <div class="faceValueBox">
 	 	<ul class="faceValue">
 	 	 <li  v-for="(item,index) in parvalue" :class="{mr0:(index+1) % 3==0,active:currentIndex==index}" @click="payType(index)">
 	 	 	<p class="font-size9 qcoins"><span><strong>{{item.flow}}</strong></span><br><span class="font-size8 element" v-if="checkphone==1&&item.objs!=''">￥{{(item.objs.length==1)?(item.objs[0].price):(item.objs[0].tag==1?item.objs[0].price:item.objs[1].price)}}元</span></p><!--优先显示省内流量--><!--{{item.objs[currentIndex].price}}-->
 	 	 	<!--{{(item.objs.length==1)?(item.objs[0].price):(item.objs[0].tag==1?item.objs[0].price:item.objs[1].price)}}-->
 	 	 </li>
 	 	</ul>
 	 	<p v-show="parvalue.length==0" class="text-center pb10 colorred font-size7">暂不支持该号码充值</p>
 	 </div>
 	</div>
 	<div class="bgcontent" v-show="checkphone==1&&parvalue.length!=0">
 	   <dl class="purchase" v-for="(item,index) in payInfo">
 	   	 <dt>
 	   	 	<p class="colorff8900 font-size10" v-show="item.price!=''"><strong class="vm">{{item.price}}元</strong><i class="purchaseType vm">{{item.tag==1?'省内':'全国'}}</i></p>
 	   	 	<!--<p class="colorff5513 font-size8" v-show="item.payInfo.price!=''">{{item.payInfo.price}}V</p>
 	   	 	<p class="font-size8 color999" v-show="item.payInfo.body!=''">支持{{item.payInfo.body}}</p>-->
 	   	 	
 	   	 </dt>
 	   	 <dd><mt-button type="primary" size="small" class="font-Yahei btnbuy" @click="btnBuy(item.pid,item.price,item.payType,item.proName,item.pics)" v-show="item.payInfo.body!=''">立即充值</mt-button></dd>
 	   </dl>
 	</div>
 	<div class="bgcontent">
 		<div class="dec" v-html="dec"></div>
 	</div>
 </div>
</template>

<script>
	import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   phone:"",
			   type:"",
			   tid:localStorage.getItem("tid"),
			  // ttype:localStorage.getItem("ttype"),
               ttype:2,
               currentIndex:"",
			   faceId:localStorage.getItem("faceId"),
			   parvalue:[],
			   payInfo:[],
			   dec:"",
			   checkphone:0,
			   title:"",
			   paysType:[],
			   proName:"",
			   pic:"",
			   pid:"",
			   cellCore:""    //号码归属地			   
			}
		},
		created:function(){
			//this.showType();
			this.showInfo();
	    },
	    methods: {
	    	returnBack(){
	       	 this.$router.go(-1);
	        }, 
	        showType(){ 
	      	this.$http.post(this.URL_PREFIX+"/category/findCategoryTopTypeById.net",{tid:this.tid,proType:this.ttype})
		  	.then((res) =>{
//		  		    console.log('打印技术')
//		  		    console.log(res);
		  		    //this.parvalue=res.data.obj.products;
		  	  	    //this.type=res.data.obj.proType[0].value;
		  	  	    //this.type=res.data.obj.proType[1].value;
		  	        this.showInfo();
		   });
	     },
	     //流量充值
	     showInfo(){   
	     	this.$http.post(this.URL_PREFIX+"/category/findCategoryTopTypeById.net",{tid:this.tid,proType:this.ttype,phone:this.phone})
		  	.then((res) =>{
		  		  this.parvalue=res.data.obj.products;
		  		  this.title=res.data.obj.tName;
		  		  this.dec=res.data.obj.proIntroduce;
		  		  this.cellCore=res.data.obj.cellCore;
		  	      var faceId=this.faceId;
		  		  var faceIdi;
		  		  if(faceId!=null){
			  		  this.parvalue.forEach(function(item,i){
			  		  	if(item.id==faceId){
			  		  	    faceIdi=i;
			  		  		return;
			  		  	}
				      });
				      this.payType(faceIdi); 
				      this.faceId=null;
			     }else{
			          this.payType(0); 
			     }
		   });
	     },
	     payType(i){  
	     	this.currentIndex=i;
	     	let legg=this.parvalue.length;
	     	if(legg!=0){
	     		this.payInfo=this.parvalue[i].objs;
	     	}
	     },
	     queryInfo(){
	     	if(this.phone.length>=11){
	     	  if(this.validatePhone()){
	     		  this.checkphone=1;
		     	  this.showInfo();
		     	}else{
		     	  this.checkphone=0;
		     	}
	     	}
	     },
	     btnBuy(pid,price,paysType,proName,pic){
	        localStorage.setItem("totalPrice",price);
	        //localStorage.setItem("price",price);
	     	localStorage.setItem("proName",proName);
	     	localStorage.setItem("type",this.type);
	     	if(pic!=null){
	     	localStorage.setItem("pic",pic.file);
	     	}
	     	localStorage.setItem("tName",this.title);
	     	localStorage.setItem("pid",pid);
	     	var obj=JSON.stringify(paysType);
	     	localStorage.setItem("payType",obj);
	     	localStorage.setItem("num","");//数量
	     	//localStorage.setItem("totalPrice","");//总金额
	     	localStorage.setItem("citycode","");//常登陆地
	     	localStorage.setItem("purpose","");//购买用途
	     	localStorage.setItem("account","");
     	   if(this.validatePhone()){
	     	localStorage.setItem("account",this.phone);
	     	this.$router.push({path: '/Order/index'});
     	   }
	     },
	     //手机号验证
     	validatePhone(){
     		var reg=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
     		if(this.phone==''){
                Toast("请输入手机号码");
                return false;
            }else if(!reg.test(this.phone)){
                Toast("手机号格式不正确");
                return false;
            }else{
            	return true;
            }
     	},
	  }
	}
</script>

<style scoped="scoped">
.faceValueBox{width: 95%;margin: 0 auto;padding: 15px 0 5px 0;overflow: hidden;}
.faceValue li{float: left; border:1px solid #ff8900; color: #ff8900;border-radius: 5px;-webkit-border-radius: 5px;width: 30%;margin: 0 4% 4% 0;display: -webkit-flex;display:flex;-webkit-align-items: center;align-items: center;-webkit-justify-content: center;justify-content: center;height: 60px;text-align: center;}
.faceValue li.mr0{margin-right: 0;}
.faceValue li.active{background: #ff8920;color: #fff;border:1px solid #ff8920;}
.faceValue li p.element{color: #ff5513;}
.faceValue li.active p.element{color: #fff;}
.purchase{padding: 20px 15px;border-bottom: 1px solid #e0e0e0;overflow: hidden;}
.purchase dt{width: 65%;float: left;line-height: 23px;margin-top: 6px;}
.purchase dd{float: right;/*margin-top: 3%;*/}
.purchase dd button{line-height: 33px;}
.purchaseType{background: #46c0ff;color: #fff;font-size: 0.7rem;border-radius: 5px;margin-left: 20px;padding: 1px 5px 1px 5px;}
.dec{width: 92%;margin: 0 auto;color: #999;font-size: 0.8rem;padding: 10px 0 20px 0;line-height: 20px;}
</style>


// WEBPACK FOOTER //
// src/views/Details/FlowDirect.vue